module.exports = __webpack_public_path__ + "img/zip-lines-1.a7617e4d.jpg";